import $ from 'jquery'
import EventEmitter from 'eventemitter3'

const EMAIL_INPUT_SELECTOR = '.subscribe-mini-form__email-input'
const ADDON_SELECTOR = '.subscribe-mini-form__addon-input'
const ADDON_HASTEXT_CLASS = 'subscribe-mini-form__addon-input--has-text'

export default class NewsletterInitiationFormController {
  constructor (element, options) {
    this._element = element
    this._settings = $.extend({}, options)
    this._eventEmitter = new EventEmitter()
    this._bindUIActions()
  }

  _updateHasText () {
    console.log('element', this._element)
    const $inputElement = $(this._element).find(
      EMAIL_INPUT_SELECTOR
    )

    console.log('$inputElement', $inputElement)
    const inputVal = $inputElement.val()

    const $textboxElement = $(this._element).find(
      ADDON_SELECTOR
    )
    if (inputVal.length > 0) {
      $textboxElement.addClass(ADDON_HASTEXT_CLASS)
    } else {
      $textboxElement.removeClass(ADDON_HASTEXT_CLASS)
    }
  }

  onSubmitEmail (callback) {
    this._eventEmitter.on('submit', callback)
  }

  offSubmitEmail (callback) {
    this._eventEmitter.removeListener('submit', callback)
  }

  onFirstFocus (callback) {
    this._eventEmitter.once('focus', callback)
  }

  offFirstFocus (callback) {
    this._eventEmitter.removeListener('focus', callback)
  }

  clear () {
    const $inputElement = $(this._element).find(
      '.page-footer__newsletter__input'
    )
    $inputElement.val('')
    this._updateHasText()
  }

  _bindUIActions () {
    const $inputElement = $(this._element).find(
      EMAIL_INPUT_SELECTOR
    )

    this._updateHasText()
    // Detect when input changes
    $inputElement.on('propertychange input', e => {
      var valueChanged = false

      if (e.type === 'propertychange') {
        valueChanged = e.originalEvent.propertyName === 'value'
      } else {
        valueChanged = true
      }
      if (valueChanged) {
        this._updateHasText()
      }
    })

    $inputElement.focus(() => {
      this._eventEmitter.emit('focus')
    })

    $(this._element).submit(e => {
      let email = ''
      const $emailInput = $(e.target).find(
        EMAIL_INPUT_SELECTOR
      )
      if ($emailInput.length > 0) {
        email = $emailInput.val()
      }

      this._eventEmitter.emit('submit', { email: email })

      return false
    })
  }
}
